<template lang="html">
  <el-row class="p-bind container">
    <el-row class="login-wrap">
      <el-row class="bind-con">
        <el-row class="bind-header">
          <el-row class="bind-logo">
            <template v-if="logo_url">
              <img :src="logo_url" alt="" width="60px" class="logo">
            </template>
            <template v-else>
              <img src="../assets/logo-yimian.svg" alt="" width="60px" class="logo">
            </template>
          </el-row>
          <template v-if="current_reset === 'reset_password'">
            <h2>{{ $t('reset.resetPasswordTitle') }}</h2>
          </template>
        </el-row>

        <el-row class="bind-content">
          <el-row v-if="current_reset === 'reset_password_success'">
            <span class="bind-success">
              <i class="el-icon-check"></i>
            </span>
            <p
              class="bind-text"
              v-html="$t('reset.reset_success_html', { app_name: resetParams.app_name, email: resetParams.email, app_url: resetParams.app_url })">
            </p>
          </el-row>

          <el-row v-if="current_reset === 'reset_password'">
            <el-form
              :model="confirmForm"
              ref="confirmForm"
              :rules="rules"
              class="bind-form">
              <el-form-item prop="app_name" :label="$t('common.application')">
                <el-input v-model="confirmForm.app_name" :disabled="true"></el-input>
              </el-form-item>
              <el-form-item prop="email" :label="$t('common.email')">
                <el-input  v-model="confirmForm.email" :disabled="true"></el-input>
              </el-form-item>
              <el-form-item prop="password" :label="$t('reset.newPassword')">
                <el-input
                  type="password"
                  :placeholder="$t('reset.newPasswordPlaceholder')"
                  v-model="confirmForm.password"
                ></el-input>
              </el-form-item>
              <el-form-item
                prop="confirmPassword"
                :label="$t('reset.confirmNewPassword')"
                style="margin-top: 16px"
              >
                <el-input
                  type="password"
                  v-model="confirmForm.confirmPassword"
                  :placeholder="$t('reset.confirmNewPasswordPlaceholder')"
                  @keyup.enter.native="confirmReset"
                ></el-input>
              </el-form-item>
              <el-form-item class="bind-btns">
                <el-col>
                  <el-button
                    @click="confirmReset"
                    type="primary">
                    {{ $t('common.resetPassword') }}
                  </el-button>
                </el-col>
              </el-form-item>
            </el-form>
          </el-row>
        </el-row>
      </el-row>
    </el-row>
  </el-row>
</template>

<script>
  export default {
    data() {
      const pwValidator = (rule, value, cb) => {
        const ptn = this.$consts.PASSWORD_REGEXP;
        if (value === '') {
          cb(new Error(this.$t('common.passwordPlaceholder')));
        } else if (!ptn.test(value)) {
          cb(new Error(this.$t('rules.password_format')));
        } else {
          cb();
        }
      };
      const pwConfirmValidator = (rule, value, cb) => {
        if (value === '') {
          cb(new Error(this.$t('common.confirmPasswordPlaceholder')));
        } else if (value !== this.confirmForm.password) {
          cb(new Error(this.$t('rules.password_repeat')));
        } else {
          cb();
        }
      };
      return {
        app_key: 'qZkZT5WZSdirdcL88wyRx5pN8tsyaqAi',
        logo_url: null,
        resetParams: {
          email: '',
          app_name: '',
          app_url: '',
        },
        confirmForm: {
          email: null,
          username: null,
          password: null,
          confirmPassword: null,
        },
        rules: {
          username: [
            { required: true, message: this.$t('rules.username'), trigger: 'change' },
          ],
          password: [
            { required: true, validator: pwValidator, trigger: 'change' },
          ],
          confirmPassword: [
            { required: true, validator: pwConfirmValidator, trigger: 'change' },
          ],
        },
        current_reset: '',
        password_error: false,
        forbid: false,
      };
    },
    methods: {
      validateUrlQuery() {
        const query = this.$route.query;
        if (!query.app_key) {
          this.$message.error(this.$t('bind.invalid_app_key'));
        } else if (!query.token) {
          this.$message.error(this.$t('bind.invalid_token'));
        }
      },
      initQuery() {
        const args = this.$route.query;
        if (args) {
          const callbackParams = {
            client_app_key: args.app_key,
            token: args.token,
          };
          this.$http.post('/api/auth/reset/callback', callbackParams).then((res) => {
            console.log('res', res);
            if (res.body.ok) {
              this.updateConfirmParams(res.body.data);
              this.logo_url = res.body.data.logo_url;
            } else if (res.body.reason === 'invalid argument' && 'token' in res.body.data) {
              this.$message.error(this.$t('bind.invalid_token'));
            } else if (res.body.reason === 'invalid argument' && 'client_app_key' in res.body.data) {
              this.$message.error(this.$t('bind.invalid_app_key'));
            }
          });
        }
      },
      updateConfirmParams(data) {
        this.resetParams = data;
        if (this.$route.query.callback_url) {
          this.resetParams.app_url = this.$route.query.callback_url;
        }

        this.current_reset = data.mode;
        this.confirmForm.email = data.email;
        this.confirmForm.app_name = data.app_name;
        this.confirmForm.app_user_id = data.app_user_id;
        if (this.current_reset === 'need_bind_user') {
          this.$message.error(this.$t('reset.needBindUserErrorMessage'));
        }
      },
      confirmReset() {
        const params = {
          client_app_key: this.$route.query.app_key,
          token: this.$route.query.token,
          password: this.confirmForm.password,
          confirm_password: this.confirmForm.confirmPassword,
          lang: localStorage.getItem('HAMLET_LANGUAGE'),
        };
        this.$http.post('/api/auth/reset_password', params).then((res) => {
          const { body } = res;
          // console.log('>>>confirmReset>>>res', res);
          if (body.ok) {
            this.$message.success(this.$t('reset.resetSuccessMessage'));
            this.current_reset = 'reset_password_success';
          } else if (body.reason === 'invalid username') {
            this.$message.error(this.$t('bind.existed_username'));
          } else if (body.reason === 'invalid argument') {
            if ('password' in body.data) {
              this.$message.error(this.$t('rules.password'));
            } else if ('confirm_password' in body.data) {
              this.$message.error(this.$t('rules.password_repeat'));
            }
          } else if (body.reason === 'not found') {
            this.$message.error(this.$t('bind.invalid_token'));
          } else if (body.err_code) {
            this.$message.error(body.reason);
          } else {
            this.$message.error(this.$t('pages.account.resetFail'));
          }
        }).catch((res) => {
          // console.log('>>>confirmReset>>error>res', res);
          const { body } = res;
          const { reason } = body;
          if (reason === 'not found') {
            this.$message.error(this.$t('bind.invalid_token'));
          } else if (body.err_code) {
            this.$message.error(reason);
          } else {
            this.$message.error(this.$t('pages.account.resetFail'));
          }
        });
      },
    },
    created() {
      this.validateUrlQuery();
      this.initQuery();
    },
  };
</script>



// WEBPACK FOOTER //
// ResetUser.vue?01ce94da